<div class="dialog-header"
cdkDrag 
cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle >
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="dialog-content">
  <p [innerHTML]="message"></p>
  @if (actions.length > 1) {
    <mat-form-field>
      <mat-label>{{ actionsLabel}}</mat-label>
      <mat-select [(value)]="actionChoice">
        @for (action of actions; track action) {
          <mat-option [value]="action.key || action.label">{{ action.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  @if (showDontAskAgain) {
    <mat-checkbox [(ngModel)]="dontAskAgain">Don't ask again.</mat-checkbox>
  }
  <button mat-flat-button (click)='cancel()'>{{ dismissLabel || "Cancel" }}</button>
  @if (!isDismissOnly) {
    <button mat-flat-button (click)='confirm()'>Confirm</button>
  }
</mat-dialog-actions>